const {comparableProducts, normalizePair, comparisonUrl, comparisonMarkup} = await import((typeof window !== 'undefined' && window.HG_ASSETS?.['comparison-model.js']) || new URL('./hg12-comparison-model.js', import.meta.url).href);

export function initComparison(doc = document, browser = window) {
  const adapt = browser.HGMarkup || (value => value);
  if (doc.body.dataset.page !== 'shop') return null;
  const products = comparableProducts(browser.HG_DATA?.products);
  if (products.length < 2) return null;
  const intro = doc.querySelector('#page-content .j-intro');
  const existing = doc.getElementById('compare-favorites');
  if (!intro || (existing && !existing.hasAttribute('data-comparison-fallback'))) return null;
  let pair = normalizePair(new URLSearchParams(browser.location.search).get('compare'), products);
  const expanded = new URLSearchParams(browser.location.search).has('compare') || browser.location.hash === '#compare-favorites';
  const markup = comparisonMarkup(products, pair, expanded);
  // Replace the static anchor in place; keep a genuine mounted component intact.
  if (existing) existing.outerHTML = adapt(markup);
  else (doc.querySelector('#page-content .v10-shop-opening') || intro).insertAdjacentHTML('afterend', adapt(markup));
  const root = doc.getElementById('compare-favorites');
  const picks = [...root.querySelectorAll('[data-comparison-pick]')];
  const status = root.querySelector('.c-status');
  const updateDisabledOptions = () => picks.forEach((pick,index) => {
    [...pick.options].forEach(option => { option.disabled = option.value === pair[1-index]; });
  });
  updateDisabledOptions();
  picks.forEach((pick,index) => pick.addEventListener('change', () => {
    // Keep the native selects alive and focused when the comparison changes.
    const candidate = pick.value;
    if (!products.some(product => product.id === candidate) || candidate === pair[1-index]) {
      pick.value = pair[index];
      return;
    }
    pair[index] = candidate;
    const parsed = doc.createElement('template');
    parsed.innerHTML = adapt(comparisonMarkup(products, pair));
    root.querySelector('.c-table').replaceWith(parsed.content.querySelector('.c-table'));
    updateDisabledOptions();
    const names = pair.map(id => products.find(product => product.id === id).name);
    status.textContent = `Comparing ${names[0]} with ${names[1]}.`;
    try { browser.history.replaceState(browser.history.state, '', comparisonUrl(browser.location.href, pair)); }
    catch (_) { /* The comparison is still usable when history is unavailable. */ }
  }));
  return {root, getPair:() => [...pair]};
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initComparison(), {once:true});
  else initComparison();
}
